export default "__VITE_ASSET__ad7499eb__"